const notifications = require('../lib/notifications');
const formValidation = require('../lib/formValidation');
const formSubmission = require('../lib/formSubmission');

window.addEventListener('load', function() {

    const signUpForm = document.getElementById('frm-signup');

    const success = function () {
        window.location.assign(window.location.origin + '/welcome');
        return null;
    };

    notifications.init(signUpForm);
    formValidation.validateFormDataOnFormSubmission(signUpForm);
    formSubmission.submitFormDataWithRecaptchaOnFormSubmission(signUpForm, success);

});
